module.exports = __webpack_public_path__ + "img/step-1-s.20ff7804.png";